import { render, staticRenderFns } from "./triContract.vue?vue&type=template&id=610a01f0&scoped=true"
import script from "./triContract.vue?vue&type=script&lang=js"
export * from "./triContract.vue?vue&type=script&lang=js"
import style0 from "./triContract.vue?vue&type=style&index=0&id=610a01f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a01f0",
  null
  
)

export default component.exports